import { get } from 'lodash-es';
import qs from 'qs';

import { Commit } from 'src/types/search';
import { safeEncode } from 'src/utils/path';

export const PATH_SEPARATOR = '/';

// So long as we reqire path: string this will never be null
export const filename = (path: string) => path.split(PATH_SEPARATOR).pop()!;

export const srcHref = (commit: Commit, path: string) => {
  const { repository, hash: commitHash } = commit;
  const href = get(repository, 'links.html.href');
  const branchName = get(repository, 'mainbranch.name');
  if (!href || !branchName || !commitHash) {
    return undefined;
  }

  const encodedPath = path
    .split(PATH_SEPARATOR)
    .map(safeEncode)
    .join(PATH_SEPARATOR);
  const query = qs.stringify({ at: branchName });
  return `${href}/src/${commitHash}/${encodedPath}?${query}`;
};
